/**
 * orga-app-api - benutzerverwaltung-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface BenutzerverwaltungBenutzerZugriff { 
    benutzer_id: string;
    ist_funktionsbereich_admin?: boolean;
    ist_tech_admin?: boolean;
    ist_admin?: boolean;
    nutzungsbedingungen_akzeptiert?: boolean;
    ist_benutzer?: boolean;
    ist_info_benutzer?: boolean;
    troubletickets_sichtbar?: boolean;
    incidentmanagement_sichtbar?: boolean;
}

